import React from 'react';
import type { Filter } from '../../@types/ElasticSearchResponse';
import type QueryFilter from '../../helpers/query-filter';
import type { CombinedFacet } from '../../utils/reselectors';

interface SelectFilterItemAdvancedProps {
  filter: Filter;
  facet: CombinedFacet;
  queryFilter: QueryFilter;
  onInclude: (filter: Filter) => void;
  onExclude: (filter: Filter) => void;
}

const SelectFilterItemAdvanced = ({
  filter,
  facet,
  queryFilter,
  onInclude,
  onExclude,
}: SelectFilterItemAdvancedProps) => {
  const isIncluded = queryFilter.contains(facet.id, filter.displayName);
  const isExcluded = queryFilter.excludes(facet.id, filter.displayName);
  return (
    <li className="filter-check-list-item">
      <div className="filter-check-list-content">
        <div
          className={`filter-check-list-option-multi${isIncluded || isExcluded ? ' is-checked' : ''}`}
        >
          <div className="filter-check-list-option-multi-action">
            <button
              type="button"
              className={`filter-check-list-option-multi-btn is-positive ${
                isIncluded ? ' is-checked' : ''
              }`}
              onClick={() => onInclude(filter)}
            >
              <i className="icon-plus no-margin" />
            </button>
            <button
              type="button"
              className={`filter-check-list-option-multi-btn is-negative${
                isExcluded ? ' is-checked' : ''
              }`}
              onClick={() => onExclude(filter)}
            >
              <i className="icon-minus no-margin" />
            </button>
          </div>
          <div className="filter-check-list-option-label">{filter.displayName}</div>
        </div>
      </div>
      <div className="filter-check-list-amout">{filter.count}</div>
    </li>
  );
};

export default SelectFilterItemAdvanced;
